import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { colors } from '../../assets/utils/colors';

const DataFetchingFeedback = () => {
    return (
        <>
            <Box
                sx={{
                    position: 'absolute',
                    top: 43,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 10,
                    // background: `linear-gradient(180deg, ${colors.bgColor1}, ${colors.bgColor2})`,
                }}
            >
                <Box sx={{ textAlign: 'center' }}>
                    <CircularProgress color="secondary" />
                </Box>
            </Box>
        </>
    );
};

export default DataFetchingFeedback;
